import React from 'react';

import { Box } from '@opendoor/bricks/core';

import { LegacyExternalLink } from 'platform/remix-run/react';

import { HOMEPAGE_URL } from 'shared/helpers/globals';
import { GenericErrorPage } from 'shared/routes/errors/GenericErrorPage';

/**
 * A page to display when a route is not found.
 *
 * TODO: maybe use www.opendoor.com/404 error page?
 */
export const NotFoundPage: React.FC<{ default?: boolean }> = () => (
  <GenericErrorPage
    reason="not-found"
    causedBy="user-error"
    headerContent="Sorry, page not found"
    errorContent={
      <Box as="span">
        Click{' '}
        <LegacyExternalLink
          analyticsName="homepage-404-redirect"
          href={HOMEPAGE_URL}
          target="_self"
          aria-label="Go to homepage"
        >
          here
        </LegacyExternalLink>{' '}
        to head home.
      </Box>
    }
  />
);
